export const newGuid: () => string = () => crypto.randomUUID();
